import { COUNTRY_NAME } from '@/utils/constants';

export const formatRemoteStudentDisplayName = (
  remoteNickname,
  isTrainer,
  isZipanService,
  remoteStudentCountryId
) => {
  const name = remoteNickname;
  const gateOpen = isTrainer && !isZipanService;
  if (!gateOpen) {
    return name;
  }
  const country = COUNTRY_NAME[remoteStudentCountryId];
  if (typeof country !== 'string' || country.trim() === '') {
    return name;
  }
  return `${name} [${country.trim()}]`;
};
